import { render } from "./BaseBarChart.vue?vue&type=template&id=52d87fac&scoped=true"
import script from "./BaseBarChart.vue?vue&type=script&lang=js"
export * from "./BaseBarChart.vue?vue&type=script&lang=js"

import "./BaseBarChart.vue?vue&type=style&index=0&id=52d87fac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d87fac"],['__file',"src/components/BaseBarChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52d87fac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52d87fac', __exports__)) {
    api.reload('52d87fac', __exports__)
  }
  
  module.hot.accept("./BaseBarChart.vue?vue&type=template&id=52d87fac&scoped=true", () => {
    api.rerender('52d87fac', render)
  })

}


export default __exports__